var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailAwards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.723,
    height: 143.696,
    viewBox: "0 0 135.723 143.696",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1886",
    "data-name": "Group 1886",
    transform: "translate(-4326.232 -8336.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M-6253.357-550.293c-29.822,18.27-45.362,38.011-27.931,49.981s38.011,28.561,52.082,16.591,12.18-24.991,24.571-32.551,22.891-36.751-3.57-40.951S-6253.357-550.293-6253.357-550.293Z",
    transform: "translate(10653.693 8925.917)",
    fill: "#f5f6fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1317",
    "data-name": "Rectangle 1317",
    width: 77.556,
    height: 60,
    rx: 9,
    transform: "translate(4353.717 8390.573) rotate(8)",
    fill: "#dae0f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1658",
    "data-name": "Group 1658",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 4348.477, 8357.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M0,33.2,39.8.573a2.531,2.531,0,0,1,3.208,0L82.814,33.2,41.407,70.245Z",
    transform: "translate(0 0)",
    fill: "#525c75"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1659",
    "data-name": "Group 1659",
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 22.505, 34.168)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 16.661,
    cy: 16.661,
    r: 16.661,
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 8.624, 0)",
    fill: "#ff6a42"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1659-2",
    "data-name": "Group 1659",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 15.049, 10.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M7.664,6.075H.642a.63.63,0,0,1-.5-.195A.5.5,0,0,1,0,5.537C0,5,0,4.468.005,3.934a1.051,1.051,0,0,1,1.014-.979c.3-.006.6,0,.9,0,.085,0,.108-.012.068-.1A2.031,2.031,0,0,1,5.255.575c.411.376.827.747,1.237,1.124.056.051.089.044.144,0a1.542,1.542,0,0,1,2.055-.007c.065.055.1.053.162,0C9.27,1.3,9.684.921,10.108.548a1.937,1.937,0,0,1,2.069-.41A1.957,1.957,0,0,1,13.5,1.759a1.822,1.822,0,0,1-.144,1.069c-.057.123-.054.125.078.126.281,0,.561,0,.842,0A1.052,1.052,0,0,1,15.332,4c0,.5,0,1,0,1.5a.567.567,0,0,1-.553.577c-.047,0-.092,0-.139,0ZM4.9,2.954H6c.036,0,.084.016.1-.033s-.024-.069-.053-.1q-.806-.73-1.613-1.461a.834.834,0,0,0-.5-.218.906.906,0,1,0-.078,1.808C4.208,2.956,4.553,2.954,4.9,2.954Zm5.513,0h.99a1.187,1.187,0,0,0,.229-.02.906.906,0,0,0,.747-.761.9.9,0,0,0-1.492-.8c-.535.478-1.066.961-1.6,1.443-.03.027-.074.054-.057.1s.072.034.112.034C9.7,2.955,10.055,2.954,10.412,2.954Z",
    transform: "translate(0 0)",
    fill: "#f7fafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M0,4.2V.179C0,0,0,0,.179,0H5.587c.182,0,.182,0,.182.188q0,3.5,0,7a1.213,1.213,0,0,1-.223.793,1.031,1.031,0,0,1-.834.422c-1.526.005-3.052,0-4.577,0C.01,8.407,0,8.348,0,8.25Q0,6.227,0,4.2Z",
    transform: "translate(8.584 6.92)",
    fill: "#f7fafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M5.756,4.2V8.238c0,.166,0,.167-.167.167h-4.5A1.058,1.058,0,0,1,0,7.316Q0,3.742,0,.168C0,0,0,0,.164,0H5.592c.164,0,.164,0,.164.169Q5.757,2.187,5.756,4.2Z",
    transform: "translate(0.993 6.92)",
    fill: "#f7fafc"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M72.147,53.722H2.618A2.618,2.618,0,0,1,0,51.1V0Z",
    transform: "translate(0 33.203)",
    fill: "#c4cadc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M0,53.722H69.529A2.618,2.618,0,0,0,72.148,51.1V0Z",
    transform: "translate(10.667 33.203)",
    fill: "#c4cadc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M0,31.492,37.752.544a2.4,2.4,0,0,1,3.043,0L78.547,31.492Z",
    transform: "translate(2.133 55.433)",
    fill: "#dae0f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M3.368.189,3.7,1.663a.243.243,0,0,0,.146.172l1.4.561a.242.242,0,0,1,.034.433l-1.3.771a.242.242,0,0,0-.118.192L3.764,5.3a.243.243,0,0,1-.4.166l-1.135-1a.242.242,0,0,0-.219-.053l-1.465.37a.242.242,0,0,1-.282-.331l.6-1.387a.242.242,0,0,0-.017-.225l-.8-1.279a.242.242,0,0,1,.228-.37l1.5.139a.242.242,0,0,0,.209-.086L2.945.087A.243.243,0,0,1,3.368.189Z",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 4435.503, 8382.368)",
    fill: "#7b7597",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 1.95,
    cy: 1.95,
    r: 1.95,
    transform: "translate(4399.777 8348.528)",
    fill: "#f7fafc",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 1.284,
    cy: 1.284,
    r: 1.284,
    transform: "translate(4341.798 8370.521)",
    fill: "#7b7597"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_265",
    "data-name": "Ellipse 265",
    cx: 1.284,
    cy: 1.284,
    r: 1.284,
    transform: "translate(4394.798 8340.521)",
    fill: "#c4cadc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_266",
    "data-name": "Ellipse 266",
    cx: 1.284,
    cy: 1.284,
    r: 1.284,
    transform: "translate(4420.798 8357.824)",
    fill: "#2c5cde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M1152.361,1951.313a6.29,6.29,0,0,1,1.38,2.739.265.265,0,0,0,.514-.045,7.925,7.925,0,0,1,.718-2.83,5.057,5.057,0,0,1,2.449-1.25.265.265,0,0,0-.025-.516,6.639,6.639,0,0,1-2.4-.787,3.451,3.451,0,0,1-1.048-2.368.265.265,0,0,0-.519-.013,7.152,7.152,0,0,1-.949,2.294c-.932,1.122-4.092,1.3-4.126,1.639C1148.28,1950.938,1151.54,1950.642,1152.361,1951.313Z",
    transform: "translate(3212.678 6441.132)",
    fill: "#dae0f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1747",
    "data-name": "Group 1747",
    transform: "translate(4337.133 8317.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1660",
    "data-name": "Group 1660",
    transform: "translate(53.7 43.386)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_85-2",
    "data-name": "Ellipse 85",
    cx: 14.637,
    cy: 14.637,
    rx: 14.637,
    ry: 14.637,
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 7.577, 0)",
    fill: "#dae0f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M8.694.488l.857,3.8a.626.626,0,0,0,.378.444l3.619,1.45A.626.626,0,0,1,13.635,7.3L10.282,9.294a.625.625,0,0,0-.3.5l-.26,3.89a.626.626,0,0,1-1.038.428L5.75,11.536a.624.624,0,0,0-.566-.137l-3.78.954A.626.626,0,0,1,.677,11.5L2.218,7.918a.627.627,0,0,0-.045-.581L.1,4.037a.626.626,0,0,1,.588-.956l3.881.36a.625.625,0,0,0,.539-.222L7.6.225A.626.626,0,0,1,8.694.488Z",
    transform: "translate(67.354 52.411) rotate(19)",
    fill: "#2c5cde"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1663",
    "data-name": "Group 1663",
    transform: "translate(4341.548 8336.697) rotate(-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1661",
    "data-name": "Group 1661",
    transform: "translate(0 20.09) rotate(-45)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_85-3",
    "data-name": "Ellipse 85",
    cx: 11.599,
    cy: 11.599,
    rx: 11.599,
    ry: 11.599,
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 6.004, 0)",
    fill: "#2c5cde"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1662",
    "data-name": "Group 1662",
    transform: "translate(14.601 14.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1155-2",
    "data-name": "Path 1155",
    d: "M5.44,4.312H.456A.447.447,0,0,1,.1,4.174.358.358,0,0,1,0,3.93c0-.379,0-.759,0-1.137A.746.746,0,0,1,.723,2.1c.213,0,.425,0,.638,0,.06,0,.077-.009.049-.072A1.442,1.442,0,0,1,3.73.408c.292.267.587.53.878.8.04.036.063.031.1,0a1.094,1.094,0,0,1,1.459,0c.046.039.072.037.115,0,.3-.271.59-.543.891-.808A1.375,1.375,0,0,1,8.643.1a1.389,1.389,0,0,1,.939,1.15,1.293,1.293,0,0,1-.1.759c-.04.088-.039.089.055.089.2,0,.4,0,.6,0a.746.746,0,0,1,.749.741c0,.355,0,.709,0,1.064a.4.4,0,0,1-.393.41c-.033,0-.066,0-.1,0ZM3.477,2.1h.785c.025,0,.059.012.07-.024S4.315,2.023,4.295,2Q3.723,1.487,3.15.968A.592.592,0,0,0,2.8.813.643.643,0,1,0,2.741,2.1C2.987,2.1,3.232,2.1,3.477,2.1Zm3.913,0h.7a.847.847,0,0,0,.163-.014.643.643,0,0,0,.53-.54A.641.641,0,0,0,7.726.975c-.38.339-.757.682-1.135,1.024-.021.019-.053.039-.041.073S6.6,2.1,6.63,2.1Z",
    transform: "translate(0 0)",
    fill: "#dae0f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156-2",
    "data-name": "Path 1156",
    d: "M0,2.983V.127C0,0,0,0,.127,0H3.965c.129,0,.129,0,.129.133q0,2.485,0,4.968a.861.861,0,0,1-.159.563.732.732,0,0,1-.592.3c-1.083,0-2.166,0-3.249,0-.088,0-.1-.042-.1-.112Q0,4.419,0,2.983Z",
    transform: "translate(6.092 4.911)",
    fill: "#dae0f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157-2",
    "data-name": "Path 1157",
    d: "M4.085,2.984V5.847c0,.118,0,.118-.118.118H.777A.751.751,0,0,1,0,5.192Q0,2.656,0,.12C0,0,0,0,.116,0H3.969c.116,0,.116,0,.116.12Q4.086,1.552,4.085,2.984Z",
    transform: "translate(0.705 4.911)",
    fill: "#dae0f2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailAwards);
export default __webpack_public_path__ + "static/media/mail-awards.6b55170223ca289099a37de5c2639d97.svg";
export { ForwardRef as ReactComponent };